import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34fcfc23"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "members"
}
const _hoisted_2 = ["title"]

import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Member } from '@/Member/member.entity';
import { useMemberModalsStore } from '@/stores/member-modals.store';

import MemberAvatar from './MemberAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LitigationMembersList',
  props: {
    members: {
        type: Array as PropType<Member[]>,
        default: () => [],
    },
    litigationName: {
        type: String,
        default: '',
    },
    maxVisible: {
        type: Number,
        default: 2,
    },
},
  setup(__props) {

const props = __props;


const { members, litigationName, maxVisible } = toRefs(props);

const { t } = useI18n();
const memberModalsStore = useMemberModalsStore();

const renderedMembers = computed(() => members.value.slice(0, maxVisible.value));
const nonRenderedMembersCount = computed(() => members.value.length - renderedMembers.value.length);
const reversedMembers = computed(() => [...renderedMembers.value].reverse());

return (_ctx: any,_cache: any) => {
  return (_unref(members).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (nonRenderedMembersCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              title: _unref(t)('listMembers.showMoreMembers'),
              class: "show-more-members",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(memberModalsStore).openLitigationMembers(_unref(members), _unref(litigationName))), ["stop"]))
            }, " +" + _toDisplayString(nonRenderedMembersCount.value), 9, _hoisted_2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reversedMembers.value, (member) => {
          return (_openBlock(), _createBlock(MemberAvatar, {
            key: member.memberId ?? member.email,
            member: member
          }, null, 8, ["member"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})